// @flow

import React, { type AbstractComponent } from 'react';
import { withTheme } from 'styled-components';
import type { Theme } from '../../types';
import type { ColorScheme } from '../../types/theme';

type RequiredProps = {|
  colorScheme: ?string,
|};

export type SchemeProps = {|
  scheme: ColorScheme,
  theme: Theme,
|};


function withScheme<P>(
  WrappedComponent: AbstractComponent<{ ...P, ...RequiredProps, ...SchemeProps }>,
): AbstractComponent<P> {
  const WithScheme = (props: { ...P, ...RequiredProps, ...SchemeProps }) => {
    const { theme, colorScheme } = props;

    const getScheme = () => {
      switch (colorScheme) {
        case 'default_light':
          return theme.schemes.defaultLight;
        case 'light':
          return theme.schemes.light;
        case 'white':
          return theme.schemes.white;
        case 'dark':
          return theme.schemes.dark;
        case 'primary':
          return theme.schemes.primary;
        case 'secondary':
          return theme.schemes.secondary;
        case 'tertiary':
          return theme.schemes.tertiary;
        default:
          return theme.schemes.default;
      }
    };

    return <WrappedComponent {...props} scheme={getScheme()} />;
  };

  // $FlowFixMe
  return withTheme(WithScheme);
}

export default withScheme;
